import React from "react"
import SkeletonParagraph from "../../additional_components/common/SkeletonParagraph"

// Loading placeholder shared by the Top Revenued / Top Downloads / Top
// Average Rating / Top App Score / Top Reviewed ranking pages — was
// duplicated identically across all of them.
export default function AppCardSkeleton({ count = 6 }) {
  return (
    <div className="skeleton-container">
      {Array.from({ length: count }).map((_, index) => (
        <div className="app-card skeleton-card" key={index}>
          <div className="app-info">
            <div>
              <SkeletonParagraph lines={3} />
            </div>
            <div className="app-metrics">
              <div className="metric-group">
                <SkeletonParagraph lines={2} />
              </div>
              <div className="metric-group">
                <SkeletonParagraph lines={2} />
              </div>
            </div>
          </div>
          <div className="app-image-container skeleton-image">
            <div className="app-image-placeholder"></div>
          </div>
        </div>
      ))}
    </div>
  )
}
